import { useCallback, useMemo } from "react";
import { FornecedorItemResponse } from "../typings";
import { showErrorAxios } from "infra/helpers/alerta";
import { Switch } from "@chakra-ui/react";
import { useToggleFornecedorStatus } from ".";
import { useLoading } from "components/GlobalLoading";

function useFornecedoresColumns({ onToogled }: { onToogled: () => void }) {
  const { isLoading, mutate: handleToggleStatus } = useToggleFornecedorStatus();

  const _handleToggleStatus = useCallback(
    (id: string, checked: boolean) => {
      handleToggleStatus(
        { nextStatus: checked, id },
        {
          onError: (err) => {
            showErrorAxios(err, "Não foi possível alterar o status.");
          },
          onSuccess: () => {
            onToogled();
          },
        }
      );
    },
    [handleToggleStatus, onToogled]
  );

  useLoading(isLoading);

  return useMemo(() => {
    return [
      {
        title: "Nome",
        dataIndex: "nome",
      },
      {
        title: "Estado",
        dataIndex: "estado",
      },
      {
        title: "Cidade",
        dataIndex: "cidade",
      },
      {
        title: "Status",
        render: (original: FornecedorItemResponse) => (
          <div>
            <Switch
              isDisabled={isLoading}
              onChange={() => {
                _handleToggleStatus(original.id, !original.ativo);
              }}
              isChecked={!!original.ativo}
            />
          </div>
        ),
      },
    ];
  }, [_handleToggleStatus, isLoading]);
}

export default useFornecedoresColumns;
